import { MutationTree } from 'vuex'
import { LocalStorageState, LocalStorageOneItem } from './state'

export enum LocalStorageMutationTypes {
  GetAllSuccess = '[LocalStorage Mutation] Get Success',
  GetOneSuccess = '[LocalStorage Mutation] Get One Success',
}

export type LocalStorageMutationPayload = {
  LocalStorage: LocalStorageState
}

export const mutations: MutationTree<LocalStorageState> = {

  [LocalStorageMutationTypes.GetAllSuccess](
    state,
    payload: LocalStorageMutationPayload,
  ) {
    state.localStorage = payload
  },

  [LocalStorageMutationTypes.GetOneSuccess](
    state,
    payload: LocalStorageOneItem,
  ) {
    state.localStorage = {...state.localStorage, payload}
  },

}
